// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2veHA","title":"Header_title__r7Hy-","left":"Header_left__3V8Wb","clinicName":"Header_clinicName__t-Ko4"};